import React from "react";
import {
  faChartPie,
  faChalkboardTeacher,
  faUserGraduate,
  faClipboardCheck,
  faChartLine,
  faBook,
  faCalendarCheck
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from '@themesberg/react-bootstrap';
import { Routes } from "../../routes";

export const TeacherMenuItems = ({ NavItem }) => {
  return (
    <>
      <NavItem
        title="Dashboard"
        link={Routes.DashboardOverview.path}
        icon={faChartPie}
      />

      <Dropdown.Divider className="my-3 border-indigo" />

      <NavItem
        title="Minhas Turmas"
        link={Routes.TeacherClasses.path}
        icon={faChalkboardTeacher}
      />

      <NavItem
        title="Planos de Aula"
        link={Routes.TeacherLessonPlans.path}
        icon={faBook}
      />

      <NavItem
        title="Meus Alunos"
        link={Routes.TeacherStudents.path}
        icon={faUserGraduate}
      />

      <NavItem
        title="Registrar Aula"
        link={Routes.TeacherClassContent.path}
        icon={faCalendarCheck}
      />

      <NavItem
        title="Frequência"
        link={Routes.TeacherAttendance.path}
        icon={faClipboardCheck}
      />

      <NavItem
        title="Notas"
        link={Routes.TeacherGrades.path}
        icon={faChartLine}
      />
    </>
  );
};

export default TeacherMenuItems;
